import { collection, getDocs, query, where, updateDoc, doc, increment } from 'firebase/firestore';
import { db } from '../firebaseConfig';
import { Ad } from '../types/ads';
import { Player } from '../types/user';
import { SubscriptionService } from './SubscriptionService';

import { SubscriptionLimits } from '../types/subscription';

export const AdService = {
    async getActiveAds(user: Player | null, limits?: SubscriptionLimits): Promise<Ad[]> {
        // Use provided limits if available, otherwise fallback to static check (or assume true/false based on caller)
        // If limits are provided, we trust the caller has already checked 'shouldShowAds' or we check it here.
        // The static method might NOT have the updated limits.

        let shouldShow = false;
        if (limits) {
            shouldShow = limits.hasAds;
        } else {
            shouldShow = SubscriptionService.shouldShowAds(user);
        }

        if (!shouldShow) {
            return [];
        }

        try {
            const adsRef = collection(db, 'ads');
            const q = query(adsRef, where('active', '==', true));
            const snapshot = await getDocs(q);

            const ads: Ad[] = [];
            snapshot.forEach(doc => {
                ads.push({ id: doc.id, ...doc.data() } as Ad);
            });

            return ads;
        } catch (error) {
            console.error("Error fetching ads:", error);
            return [];
        }
    },

    async trackImpression(adId: string) {
        try {
            const adRef = doc(db, 'ads', adId);
            await updateDoc(adRef, {
                impressions: increment(1)
            });
        } catch (error) {
            console.error("Error tracking impression:", error);
        }
    },

    async trackClick(adId: string) {
        try {
            const adRef = doc(db, 'ads', adId);
            await updateDoc(adRef, {
                clicks: increment(1)
            });
        } catch (error) {
            console.error("Error tracking click:", error);
        }
    }
};
